var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{staticClass:"mt-0 mb-1",attrs:{"input-value":_vm.value === 1,"hide-details":"","dense":""},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }